import React, { useContext } from 'react';

import styled from '@emotion/styled';

import useIndicateIssues from '../../../../hooks/dashboard/BaDriverVerification/useIndicateIssues';
import {
  IndicateIssuesDataType,
  IndicateIssuesInitialValues,
  IndicateIssuesSchema,
} from '../../../../models/dashboard/ba-verification/indicate-issues';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import {
  CustomRectangularStackedRadio,
  CustomStackedRectangularRadioFieldGroup,
} from '../../../FormCom/CustomStackedRectangularRadioField';
import { FormComponent } from '../../../FormCom/FormComponent';
import { TableContext } from '../../../Table/TableContext';
import ModalContainer from '../../ModalContainer';
import { ModalContext } from '../../ModalContext';

interface IndicateIssuesModalProps {
  data?: any;
}

const IndicateIssuesModal: React.FC<IndicateIssuesModalProps> = ({ data }) => {
  const modalContext = useContext(ModalContext);
  const { setIndicateIssues, loading } = useIndicateIssues();
  const tableContext = useContext(TableContext);

  const onSubmit = (value: IndicateIssuesDataType) => {
    setIndicateIssues(
      {
        status: 'Processed',
        ...value,
      },
      data?.id ?? '',
      () => {
        modalContext?.setShowModal(false);
        tableContext?.setRefreshTable(!tableContext?.refreshTable);
      },
    );
  };

  return (
    <ModalContainer label='Indicate Issues'>
      <FormComponent
        initialValues={IndicateIssuesInitialValues}
        schema={IndicateIssuesSchema}
        onSubmit={onSubmit}
        className={'large-gap'}
      >
        <CustomStackedRectangularRadioFieldGroup
          name='issue'
          label='Select an issue'
        >
          <CustomRectangularStackedRadio
            name='issue'
            value="Unclear rider's card"
          >
            Unclear rider's card
          </CustomRectangularStackedRadio>
          <CustomRectangularStackedRadio
            name='issue'
            value='Unclear profile picture'
          >
            Unclear profile picture
          </CustomRectangularStackedRadio>
          <CustomRectangularStackedRadio
            name='issue'
            value='Irrelevant image uploaded'
          >
            Irrelevant image uploaded
          </CustomRectangularStackedRadio>
          {/* <CustomRectangularStackedRadio
            name='issue'
            value='Issue confirming DOB'
          >
            Issue confirming D.O.B
          </CustomRectangularStackedRadio>
          <CustomRectangularStackedRadio
            name='issue'
            value='Inaccurate driver name'
          >
            Inaccurate driver name
          </CustomRectangularStackedRadio> */}
        </CustomStackedRectangularRadioFieldGroup>

        <ButtonArea>
          <FormSubmitButton
            className='clear fill'
            onClick={() => modalContext?.setShowModal(false)}
            btnType='button'
          >
            Cancel
          </FormSubmitButton>
          <FormSubmitButton loading={loading} className='fill'>
            Save
          </FormSubmitButton>
        </ButtonArea>
      </FormComponent>
    </ModalContainer>
  );
};

export default IndicateIssuesModal;

const ButtonArea = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;
